import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Translate } from 'react-localize-redux';
import Icon, { IconSizes } from '../../components/foundations/Icon';
import { STEP_STATUS, STEP_STATUS_ICON } from '../constants';
import css from './AgentActivity.css';

const TRANSLATION_PREFIX = 'STATIC.PAGES.ANALYSIS_CHAT.AGENT_ACTIVITY';

const StepStatusIcon = ({ status }) => {
    const iconConfig = STEP_STATUS_ICON[status];
    if (!iconConfig) return null;
    return (
        <Icon
            name={iconConfig.name}
            size={IconSizes.X_SMALL}
            variant={iconConfig.variant}
            className={classNames(css.historyStatusIcon, { [css.spinner]: iconConfig.isSpinning })}
        />
    );
};

StepStatusIcon.propTypes = {
    status: PropTypes.oneOf(Object.values(STEP_STATUS)),
};

const AgentActivityHistoryList = ({ steps }) => (
    <div className={css.historyList} role="list">
        {steps.map((step, index) => (
            <div className={css.historyRow} role="listitem" key={step.step_id || index}>
                <span className={css.historyDotWrap} aria-hidden="true">
                    <span className={css.historyDot} />
                    <span className={css.historyConnector} />
                </span>
                <span className={css.historyName}>
                    {step.title || <Translate id={`${TRANSLATION_PREFIX}.STEP_FALLBACK`} data={{ index: index + 1 }} />}
                </span>
                <StepStatusIcon status={step.status} />
            </div>
        ))}
    </div>
);

AgentActivityHistoryList.propTypes = {
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            step_id: PropTypes.string,
            title: PropTypes.string,
            status: PropTypes.oneOf(Object.values(STEP_STATUS)),
        })
    ).isRequired,
};

export default AgentActivityHistoryList;
